export default "__VITE_ASSET__D0UrYH2M__"